import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const DesignVsMeetingHaug = HelpVideo(
    'DesignVsMeetingHaug',
    'Editor / Basics',
    'Design Mode & Meeting Mode',
    10020,
    'https://s.ludi.co/app/haug/10020-design-vs-meeting.mp4',
);
